import { combineReducers } from "redux";

import dashboard from "./dashboard";
import metric from "./metric";

export default combineReducers({
  dashboard,
  metric,
});
